import { defaultTheme, ThemeConfig } from './default';

// 所有主题配置
export const themes: Record<string, any> = {
  default: defaultTheme,
};

// 根据公司ID获取主题配置
export function getThemeByCompanyId(companyId: string): any {
  return themes[companyId] || themes.default;
}

// 主题列表
export const themeList = Object.values(themes);

export { defaultTheme };
export type { ThemeConfig };
